import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import { buildDataBindSyntax } from "../buildDataBindSyntax";
import K_PaneLink from "../templates/K_PaneLink";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PaneLinkOptions extends ComponentOptions {
    title?: string;
    label?: string;
    bindLabel?: string;
    bsc?: string;
    href?: string;
    toolTip?: string;
}

export class PaneLink extends TemplateComponent {

    options: PaneLinkOptions;

    constructor(options: PaneLinkOptions) {
        super(K_PaneLink, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.label;
        options.bindLabel = buildDataBindSyntax(options.bindLabel, "label");
        options.toolTip = ll(options.toolTip);
    }

    create() {
        if (this.options.toolTip) {
            toolTip({
                selector: $("#" + this.id)
            });
        }
    }

}
